import { render, staticRenderFns } from "./staff-change-info-comment.vue?vue&type=template&id=7860200c"
import script from "./staff-change-info-comment.vue?vue&type=script&lang=js"
export * from "./staff-change-info-comment.vue?vue&type=script&lang=js"
import style0 from "./staff-change-info-comment.vue?vue&type=style&index=0&id=7860200c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports